import { Injectable } from '@angular/core';
import { plainToClass } from 'class-transformer';
import { Subscription } from 'rxjs';
import { map, switchMap, take, takeWhile } from 'rxjs/operators';
import { WEBSOCKET_USER_SNAPSHOTFILE } from 'src/app/common/const';
import { NOTIFICATIONS_STORE_NAME, Notification, NotificationType } from 'src/app/common/model/notification';
import { UserProfileService } from 'src/app/common/service/user-profile.service';
import { WebsocketClient } from 'src/app/common/service/websocket-client.service';
import { UserSettingsService } from 'src/app/settings/service/user-settings.service';
import { StoreService } from 'src/app/store/service/store.service';

@Injectable(
    { providedIn: 'root' }
)
export class SnapshotNotifierService {

    userSnapshotFilesSubscription: Subscription;

    constructor(private websocketClient: WebsocketClient, private userProfile: UserProfileService,
        private storeService: StoreService, private settings: UserSettingsService) { }


    init(): void {
        this.websocketClient.websocketConnectionConnected$
            .subscribe(() => {
                this.connectToSnapshotFilesSub();
            });
    }

    private connectToSnapshotFilesSub(): void {
        this.userSnapshotFilesSubscription = this.userProfile.updateUserProfile$
            .pipe(
                take(1),
                switchMap(profile => this.websocketClient.subscribe(WEBSOCKET_USER_SNAPSHOTFILE + profile.idKeycloak)),
                takeWhile(_data => this.settings.isNotifyOnNewSnapshotFileEnabled()),
                map(response => plainToClass(SnapshtFileCreatedDto, response))
            )
            .subscribe(snapshot => this.storeService.store<Notification>(
                NOTIFICATIONS_STORE_NAME,
                [{ type: NotificationType.SNAPSHOT_FILE, time: new Date(), data: snapshot, url: '/files/snapshots' }]
            ));
    }

}

export class SnapshtFileCreatedDto {
    readonly sideNumber: string;
    readonly idSnapshotFile: number;
}
